export enum ClientType {
    WEB_CLIENT = "WEB_CLIENT"
}
